import { render } from "./CqUpdate.vue?vue&type=template&id=04486578&scoped=true"
import script from "./CqUpdate.vue?vue&type=script&lang=js"
export * from "./CqUpdate.vue?vue&type=script&lang=js"

import "./CqUpdate.vue?vue&type=style&index=0&id=04486578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04486578"]])

export default __exports__